import { isNull } from 'lodash'

import constants from 'constants/index'

const userCertificationStatus = (user) => {
  const { TRAINING_JOURNEY_TRAILS } = constants.trailsJourney

  const allConcludedTrainingTrails = [
    user?.fundamentalConceptsData,
    user?.cleanTableAndScreenData,
    user?.artificialIntelligenceData,
    user?.privacyByDesignData,
  ].filter((trail) => !isNull(trail)).length

  if (allConcludedTrainingTrails === 0) {
    return 'Pendente'
  }

  const percentage =
    (allConcludedTrainingTrails / TRAINING_JOURNEY_TRAILS.length) * 100

  return `${percentage}% Concluído`
}

export default userCertificationStatus
